/* eslint-disable */

export enum CustomerType {
	Private = 1,
	Company = 2,
	Intercompany = 3,
	
}
